var exports = {
  "AQ": "menuButton__IIeMln",
  "Kp": "buttonName__WRO_KY",
  "kU": "responsiveIcon__TQPOg9",
  "sV": "menuHeading__0H0mqy",
};

module.exports = exports;
